import { getCameraIcon } from "./CameraIconPicker";
import { Badge } from "@/components/ui/badge";
import { cn, formatCameraNumber } from "@/lib/utils";
import type { Camera } from "@/types/camera-plans";

interface UnplacedCamerasSidebarProps {
  cameras: Camera[];
  selectedCameraId: string | null;
  onSelectCamera: (id: string | null) => void;
  onDragStart: (camera: Camera) => void;
}

export function UnplacedCamerasSidebar({
  cameras,
  selectedCameraId,
  onSelectCamera,
  onDragStart,
}: UnplacedCamerasSidebarProps) {
  if (cameras.length === 0) return null;

  return (
    <div className="absolute bottom-4 left-4 z-10 bg-background/90 backdrop-blur-sm rounded-lg border p-3 max-w-[200px] max-h-[200px] overflow-y-auto">
      <p className="text-xs font-medium text-muted-foreground mb-2">
        Unplaced ({cameras.length})
      </p>
      <div className="space-y-1">
        {cameras.map((camera) => {
          const Icon = getCameraIcon(camera.icon);
          return (
            <div
              key={camera.id}
              draggable
              className={cn(
                "flex items-center gap-2 px-2 py-1.5 rounded cursor-grab active:cursor-grabbing text-sm hover:bg-muted transition-colors",
                selectedCameraId === camera.id &&
                  "bg-primary/10 ring-1 ring-primary",
              )}
              onClick={() =>
                onSelectCamera(
                  camera.id === selectedCameraId ? null : camera.id,
                )
              }
              onDragStart={(e) => {
                e.dataTransfer.setData("camera-id", camera.id);
                onDragStart(camera);
              }}
            >
              <Icon
                className="h-3.5 w-3.5 flex-shrink-0"
                style={{ color: camera.color }}
              />
              <span className="font-mono text-xs font-medium truncate">
                {formatCameraNumber(camera.number)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
